import * as React from 'react';

const FastShipperBadge32 = ({ title, titleId, ...props }) => /* @__PURE__ */ React.createElement("svg", { fill: "none", viewBox: "0 0 32 32", width: 32, height: 32, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement(
  "path",
  {
    fill: "#C9F0EE",
    d: "M32 16c0 8.836-7.163 16-16 16S0 24.836 0 16 7.164 0 16 0s16 7.163 16 16"
  }
), /* @__PURE__ */ React.createElement(
  "path",
  {
    fill: "#007782",
    d: "M6.376 8.186a.926.926 0 0 0-.88.739.607.607 0 0 0 .62.738h15.23c1.286 0 2.38.625 2.924 1.67l1.425 2.734c.34.653.443 1.429.294 2.22l-.667 3.553c-.119.633-.732 1.143-1.376 1.143h-.48a1 1 0 0 0-.136.012 2.952 2.952 0 0 0-5.597-.012h-2.965a2.952 2.952 0 0 0-5.593 0H8.82c-.655 0-1.09-.526-.968-1.17l.827-4.38c.077-.409-.196-.743-.61-.748a.926.926 0 0 0-.887.73l-.827 4.38c-.277 1.467.714 2.666 2.204 2.666h.509a2.951 2.951 0 0 0 5.805 0h2.754a2.951 2.951 0 0 0 5.804 0h.254c1.465 0 2.862-1.162 3.133-2.605l.667-3.552c.206-1.096.064-2.17-.407-3.073l-1.425-2.735c-.753-1.446-2.268-2.31-4.048-2.31zm7.046 13.74a1.45 1.45 0 1 1-2.901 0 1.45 1.45 0 0 1 2.9 0Zm7.108 1.451a1.45 1.45 0 1 1 0-2.901 1.45 1.45 0 0 1 0 2.901"
  }
), /* @__PURE__ */ React.createElement(
  "path",
  {
    fill: "#007782",
    d: "M6.975 11.343a.926.926 0 0 0-.88.738.607.607 0 0 0 .62.74h4.795a.93.93 0 0 0 .88-.74.607.607 0 0 0-.62-.738zm13.393.921-.424 2.402c-.09.507.255.917.77.917h2.234c.758 0 1.347-.844 1.012-1.45l-1.22-2.212c-.198-.36-.583-.574-1.033-.574h-.247a1.15 1.15 0 0 0-1.092.917"
  }
));
FastShipperBadge32.Size = 32;
FastShipperBadge32.Title = "FastShipperBadge";

export { FastShipperBadge32 as default };
